import ReactMarkdown from "react-markdown";
import Button from "./Button";
import Link from "next/link";

function SimpleMarkdownRenderer(props: { mdxFile: any; showMoreLink?: string; className?: string }) {
	const {mdxFile, showMoreLink} = props;

	const showMore = showMoreLink ?? "";
	const className = props.className ?? "";

	const md = (
		<ReactMarkdown
			remarkPlugins={[]}
			allowedElements={["h2", "h3", "p", "ul", "ol", "li", "a"]}
			components={{
				p({node, className, children, ...props}) {
					return <p className="py-6">{children}</p>;
				},
				a(props) {
					return <Link href={props.href!}>{props.children}</Link>;
				},
				h3({children, level, node, ...props}) {
					return (
						<>
							<h3 className="mb-6 mt-8">{children}</h3>
						</>
					);
				},
				h2({children, level, node, ...props}) {
					if (children.length === 1 && children[0] && (children[0] as string).startsWith("metadata:")) {
						return <></>;
					}
					return (
						<>
							<h2 className="my-6">{children}</h2>
						</>
					);
				},
				ul(props) {
					return <ul className="list-disc pl-10">{props.children}</ul>;
				},
				ol(props) {
					return <ol className="list-decimal pl-10">{props.children}</ol>;
				},
			}}
		>
			{mdxFile}
		</ReactMarkdown>
	);
	return (
		<div>
			{showMore === "" ? (
				md
			) : (
				<>
					<div className={`${className}`}>
						{md}
					</div>
					<div className="max-w-[200px]">
						<Button text={"Mehr erfahren"} transparent={false} border={false} href={showMore} padding={"px-6 py-[14px]"} className="mt-5 rounded-[10px]"/>
					</div>
				</>
			)}
		</div>
	);
}

export default SimpleMarkdownRenderer;
